import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const AboutFrame = () => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 3,
        boxShadow: 3,
        backgroundColor: "#fafafa",
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
        About MyBotGP
      </Typography>

      <Typography
        variant="body1"
        sx={{ lineHeight: 1.7, color: "text.secondary" }}
      >
        JifJaff have launched a brand of robot <b>(MyBotGP)</b> within Primary
        Care to automate repetitive GP tasks. MyBotGP files normal pathology
        test results based on filing rules specified by the practice user.
      </Typography>

      <Box mt={2}>
        <Typography
          variant="body1"
          sx={{ lineHeight: 1.7, color: "text.secondary" }}
        >
          The MyBotGP automation workflow will login to EMIS/Systm One, navigate
          to the blood test result screen and, based on the Pathology Test
          Categories & Filing Rules specified within the set-up panel, MyBotGP
          will file the normal test result.
        </Typography>
      </Box>
    </Paper>
  );
};
export default AboutFrame;
